import React, { Component } from 'react';
import {connect} from "react-redux";
import update from 'immutability-helper';
import {Alert, Button, Col, Form, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap";
import * as EmailValidator from 'email-validator';
import * as InviteActions from "../actions/InviteActions";
import {Link} from "react-router-dom";
import {LinkContainer} from "react-router-bootstrap";
import {PRICE_PER_USER, TIER_FREE} from "../constants";
import Loading from "../components/Loading";


class TeamPage extends Component {

    constructor(){
        super();

        this.state = {
            showForm: false,
            form: {
                name: "",
                email: "",
            },
            message: null,
            waiting: false,
        }
    }

    handleChange(event) {
        this.setState({form:
            update(this.state.form, {
                [event.target.name]: {$set: event.target.value}
            })
        });
    }

    componentWillReceiveProps(nextProps){
        if(this.state.waiting && !nextProps.invites.creating){
            this.props.history.push("/team")
        }
    }

    submitForm(event){
        event.preventDefault();

        let valid = true;

        const {name, email} = this.state.form;

        if(!name){
            this.setState({message: {type: "danger", "title": "Error", message: "Please provide a name."}})
            valid = false;
        }
        if(!email || !EmailValidator.validate(email)){
            this.setState({message: {type: "danger", "title": "Error", message: "Please enter a valid e-mail address."}})
            valid = false;
        }

        if(valid){
            this.setState({message: null, waiting: true})

            this.props.createInvite(name, email);
        }
    }

    render() {

        const {team} = this.props;
        const {message} = this.state;


        if(!team) return <div>Loading</div>

        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Invite new user
                        <small>{team.name}</small>
                        {this.state.waiting ? (
                            <Loading right loading/>
                        ) : (
                            <Link to = "/team">
                                <Button className="pull-right">
                                    <Glyphicon glyph="remove"/>
                                </Button>
                            </Link>
                        )}
                    </h1>
                </div>
                <div className="card-body">

                    {message && (
                        <Alert bsStyle={message.type} onDismiss={() => this.setState({message: null})}>
                            <h4>{message.title}</h4>
                            {message.message}
                        </Alert>
                    )}
                    {team.tier === TIER_FREE && (
                        <Alert bsStyle="danger">
                            <h4>You can't invite new users</h4>
                            Because you are currently on the free tier, you are not able to invite new users. Please consider upgrading to the premium tier.<br /><br />
                            <LinkContainer to="/upgrade"><Button>Upgrade to premium</Button></LinkContainer>
                        </Alert>
                    )}

                    <Form horizontal style={{margin: "15px"}} onSubmit={this.submitForm.bind(this)}>
                        <FormGroup>
                            <Row>
                                <Col sm={3}>
                                    Name
                                </Col>
                                <Col sm={9}>
                                    <FormControl componentClass="input" type="text" name="name" value={this.state.form.name} onChange={this.handleChange.bind(this)} />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm={3}>
                                    E-mail address
                                </Col>
                                <Col sm={9}>
                                    <FormControl componentClass="input" type="text" name="email" value={this.state.form.email} onChange={this.handleChange.bind(this)} />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col smOffset={3} sm={9}>
                                    <small style={{color: "#666"}}><em>Note that each additional user will add &euro;{parseFloat(Math.round(PRICE_PER_USER * 100) / 100).toFixed(2)} to your monthly bill.</em></small>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col smOffset={3} sm={9}>
                                    <Button type="submit" bsStyle="primary">
                                        Invite
                                    </Button>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    team: state.teams.active,
    invites: state.invites
}), dispatch => ({
    createInvite: (name, email) => dispatch(InviteActions.createInvite({name, email})),
}))(TeamPage);


// WEBPACK FOOTER //
// ./src/pages/AddTeamMemberPage.js